import React, { useState, useMemo, useEffect, useContext } from 'react';
import Button from '../../../../components/UI/Button';
import SubheadingWithDivider from '../UI/SubheadingWithDivider';
import css from './housing_information.module.scss';
import Cleave from '../../../../components/UI/CustomInputField/CustomCleaveField';
import { useCreditClient } from '../../../../services/credit';
import Modal from '../UI/Modal';
import { AnalyticsContext } from '../../../../ModularReduxAnalytics';

export default function HousingInformation({
  updateCreditApplication,
  authToken,
  handleCreditError,
  clearError
}) {
  const creditApplicationClient = useMemo(() => useCreditClient(), []);
  const [housingCost, setHousingCost] = useState<string>('');
  const [displayInfoModal, setDisplayInfoModal] = useState<boolean>(false);
  const { analytics } = useContext(AnalyticsContext);

  useEffect(() => {
    window.scrollTo(0, 0);
    analytics.page('Registration', 'Credit Application Housing Information');
  }, []);

  const handleNextClick = async () => {
    if (housingCost) {
      try {
        await creditApplicationClient.submitHousingInformation({
          authToken,
          monthlyHousingCost: parseFloat(housingCost)
        });
        clearError();
        updateCreditApplication();
      } catch {
        handleCreditError();
      }
    } else {
      handleCreditError('Please enter your monthly housing cost amount.');
    }
  };

  return (
    <>
      {displayInfoModal && (
        <Modal
          header="Monthly housing cost"
          subheader="Only put the amount you pay each month."
          option="Ok"
          optionAction={() => setDisplayInfoModal(false)}
          secondaryOption={undefined}
          secondaryOptionAction={undefined}
        />
      )}
      <SubheadingWithDivider />
      <h1>Housing information</h1>
      <SubheadingWithDivider heading="Please tell us about your housing expenses" />
      <div className={css.subheadingContainer}>
        <h3 className={css.subheading}>
          How much do you pay in rent or mortgage each month?
        </h3>
        <div className={css.iconContainer}>
          <img
            data-testid="more-housing-info-icon"
            className={css.informationIcon}
            src="/static/informational-icon.svg"
            onClick={() => {
              setDisplayInfoModal(true);
            }}
          />
        </div>
      </div>
      <Cleave
        options={{
          prefix: '$',
          rawValueTrimPrefix: true,
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          numeralDecimalScale: 2,
          numeralPositiveOnly: true
        }}
        maxlength="7" // Cleave makes this value a weird one but it is verified.
        placeholder="Monthly housing cost"
        inputMode="numeric"
        pattern="[0-9\.]*"
        rawValue={true}
        value={housingCost}
        onChange={value => {
          setHousingCost(value);
        }}
        data-e2e="housing-information"
        data-testid="housing-information"
        allowFullStory={false}
      />
      <Button text="Next" onClick={handleNextClick} />
    </>
  );
}
